import {
  takeLatest, call, put,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import { updateBrochurePriceResponse, updateBrochurePriceRequest, updateBrochurePriceFail } from '../../slices/brochure';
import { priceSuccess } from '../../slices/cruise';
import getPriceBreakdownsFromBrochureTrip from '../../../helpers/getPriceBreakdownsFromBrochureTrip';

function* updateBrochurePriceWorker({
  payload: {
    id,
  },
}) {
  try {
    const url = `/brochure/updatePrice?brochureId=${id}`;

    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data && data.id) {
      yield put(priceSuccess(getPriceBreakdownsFromBrochureTrip(data.trip)));
      yield put(updateBrochurePriceResponse(data));
    } else {
      yield put(updateBrochurePriceFail({
        error: 'There is problem with your request. please try again.',
      }));
    }
  } catch (error) {
    let errorMessage = 'There is problem with your request. please try again.';
    if (error && error.response && error.response.data) {
      errorMessage = `${error.response.data.title} ${error.response.data.detail}`;
    }
    yield put(updateBrochurePriceFail({
      error: errorMessage,
    }));
  }
}

function* updateBrochurePriceWatcher() {
  yield takeLatest(updateBrochurePriceRequest.toString(), updateBrochurePriceWorker);
}

export default updateBrochurePriceWatcher;
